<template>
  <v-snackbar
    color="#ffffff"
    v-model="SnackBarComponent.SnackbarVmodel"
    elevation="24"
    timeout="3000"
    location="top"
  >
    <span
      class="text-center"
      :class="`text-${SnackBarComponent.SnackbarColor}`"
    >
      <v-icon
        size="small"
        location="start"
        :color="SnackBarComponent.SnackbarColor"
      >
        {{
          SnackBarComponent.SnackbarColor == "green"
            ? "mdi-checkbox-marked-circle"
            : SnackBarComponent.SnackbarColor == "red"
            ? "mdi-close-circle"
            : ""
        }}
      </v-icon>
      <span>{{ ` ${SnackBarComponent.SnackbarText}` }}</span>
    </span>
  </v-snackbar>
</template>
<script>
export default {
  props: {
    SnackBarComponent: Object,
  },
};
</script>
